import React from 'react';
import PropTypes from 'prop-types';
import { noop, map, replace } from 'lodash/fp';
import { coalesce } from '@gcc/nodash';
import {
  RadioButtonGroup,
  RadioButtonRow,
  RadioButton,
  Required,
  RadioButtonCircle,
  StyledTooltip,
} from './styles';

const removeSpaces = replace(/\s/, '-');

const RadioButtonQuestion = ({
  name,
  label,
  additionalLabel,
  options,
  value,
  onChange,
  required,
  id,
  thin,
}) => {
  const htmlId = removeSpaces(id || name);

  return (
    <RadioButtonGroup id={htmlId} thin={thin}>
      <span>
        {label}
        {label && required && <Required>*</Required>}
      </span>

      {additionalLabel}

      <RadioButtonRow>
        {map((opt) => {
          const optLabel = coalesce(opt.label, opt);
          const optValue = coalesce(opt.value, opt);
          const optToolTip = coalesce(opt.toolTip, opt);

          return (
            <RadioButton key={optValue} data-for={optLabel} data-tip={optToolTip}>
              { opt.toolTip && <StyledTooltip id={optLabel} /> }
              <input
                id={removeSpaces(`${htmlId}_${optValue}`)}
                type="radio"
                name={name}
                value={optValue}
                onChange={() => onChange(optValue)}
                checked={value === optValue}
                required={required}
              />
              <RadioButtonCircle selected={value === optValue} />
              <span>{optLabel}</span>
            </RadioButton>
          );
        })(options)}
      </RadioButtonRow>
    </RadioButtonGroup>
  );
};
RadioButtonQuestion.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
      toolTip: PropTypes.string,
    })),
  ]).isRequired,
  id: PropTypes.string,
  additionalLabel: PropTypes.node,
  onChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  required: PropTypes.bool,
  thin: PropTypes.bool,
};
RadioButtonQuestion.defaultProps = {
  id: '',
  label: null,
  onChange: noop,
  value: '',
  required: false,
  additionalLabel: null,
  thin: false,
};
export default RadioButtonQuestion;
